import React from 'react'
import { ErrorMessage } from 'formik'
import BEM from '@iui-kit/utils/bem'

const bem = new BEM(require('./GroupList.css'))

interface Props {
  name: string
}

const GroupList: React.FC<Props> = ({ name, children }) => {
  return (
    <div className={bem.b('GroupList').show()}>
      {React.Children.map(children, (item, idx) => {
        return (
          <li
            key={idx}
            className={bem
              .b('GroupList')
              .e('item')
              .show()}
          >
            {item}
          </li>
        )
      })}
      <ErrorMessage
        component="div"
        className={bem
          .b('GroupList')
          .e('error')
          .show()}
        name={name}
      />
    </div>
  )
}

export default GroupList
